import React, { useEffect } from 'react';
import { Options } from '.';
import ListingSelect from './listing-select';

const ListingFilters = ({
  filterLabel,
  filterLabelMobile,
  filters,
  selectedLocations,
  handlerSelectedLocation
}: {
  filterLabel: string;
  filterLabelMobile: string;
  filters: Options[];
  selectedLocations: string[];
  handlerSelectedLocation: (value: string[]) => void;
}) => {
  useEffect(() => {
    if (selectedLocations.length === 0) {
      handlerSelectedLocation(['all']);
    }
  }, [selectedLocations]);

  const onChange = (ids: string[], isMobile?: boolean) => {
    // If 'all' is selected, reset the selection to just 'all'
    if (ids.includes('all')) {
      handlerSelectedLocation(['all']);
      return;
    }

    // Toggle the selection state of each id
    let currentSelectionSet = new Set<string>();

    if (!isMobile) {
      currentSelectionSet = new Set(selectedLocations);
      // Remove 'all' from the current selection if it exists
      currentSelectionSet.delete('all');
      ids.forEach(id => {
        currentSelectionSet.has(id) ? currentSelectionSet.delete(id) : currentSelectionSet.add(id);
      });
    } else {
      currentSelectionSet = new Set(ids);
    }

    handlerSelectedLocation(Array.from(currentSelectionSet));
  };

  return (
    <div className="listings-filters">
      <label className="filter-label" htmlFor="filter">
        {filterLabel}
      </label>
      <div className="listings-select__wrapper">
        <ListingSelect
          placeholder={filterLabelMobile}
          options={filters}
          onChange={onChange}
          selectedLocations={selectedLocations}
        />
      </div>

      <ul className="filters-list">
        {filters &&
          filters.map((filter, index) => (
            <li key={index}>
              <button
                value={filter.id}
                className={`btn btn--outline ${selectedLocations.includes(filter.id) ? 'active' : ''}`}
                onClick={e => {
                  const target = e.target as HTMLButtonElement;
                  onChange([target.value.toLowerCase()]);
                }}
                type="button"
              >
                {filter.value}
              </button>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ListingFilters;
